import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";

// Get list of Sofia credit packages
export const getSofiaPackages = async () => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-packages`)
}

// Purchase Sofia credits (top up)
export const createSofiaPurchase = async (data) => {
  return api({}, true).post(`/${PUBLIC_V1}/sofia-purchases`, data)
}

// Get Sofia credit balance
export const getSofiaBalance = async () => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-credit-wallets`)
}

// Get payment status
export const getPaymentStatus = async () => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-purchases/payment-status`)
}

// Get list listing sofia
export const getListListingSofia = async (params) => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-properties`, { params })
}

// Post share credit
export const postShareCredit = async (data) => {
  return api({}, true).post(`/${PUBLIC_V1}/sofia-user-credit-allocations`, data)
}

// Get list marketing sofia
export const getListMarketingSofia = async (params) => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-credit-wallets/users`, { params })
}

// Get detail listing sofia
export const getDetailListingSofia = async (slug) => {
  return api({}, true).get(`/${PUBLIC_V1}/property/offices/${slug}`)
}

// Get sofia listing images
export const getSofiaListingImages = async (slug) => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-properties/${slug}/images`)
}

// Post sofia listing images
export const postSofiaListingImages = async (slug, data) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/${slug}/sofia-jobs`, data)
}

export const postSofiaListingImagesCancel = async (slug) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/${slug}/sofia-jobs/cancel`)
}

export const postSofiaListingImagesUse = async (slug) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/${slug}/sofia-jobs/apply`)
}

// Get credit history/transactions
export const getCreditHistory = async (params) => {
  return api({}, true).get(`/${PUBLIC_V1}/sofia-credit-wallets/history`, { params })
}